module.exports = __webpack_public_path__ + "img/gh-30513-5-36.prt.70fbaa7f.jpg";